import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const About = () => {
  const { t } = useLang();
  const A = t.about;

  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="container-vel grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-5"
        >
          <div className="overline mb-5" data-testid="about-overline">
            {A.overline}
          </div>
          <h2
            data-testid="about-heading"
            className="font-heading text-4xl sm:text-5xl text-navy font-light leading-[1.05] tracking-tight"
          >
            {A.headlinePre}{" "}
            <em className="not-italic underline decoration-coral decoration-2 underline-offset-8">
              {A.headlineHighlight}
            </em>
            .
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="lg:col-span-7 lg:pl-8 border-l border-navy/10"
        >
          <p className="font-body text-base sm:text-lg text-ink-muted leading-relaxed font-light">
            {A.intro}
          </p>

          <ul
            data-testid="about-items-list"
            className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4"
          >
            {A.items.map((item, i) => (
              <li
                key={item}
                data-testid={`about-item-${i}`}
                className="flex items-start gap-3"
              >
                <Check
                  size={18}
                  strokeWidth={2}
                  className="text-coral mt-1 shrink-0"
                />
                <span className="font-body text-base text-navy leading-snug">
                  {item}
                </span>
              </li>
            ))}
          </ul>

          <div
            data-testid="about-not-list"
            className="mt-10 border-t border-navy/15 pt-6 space-y-3"
          >
            {A.notList.map((line, i) => {
              const isLast = i === A.notList.length - 1;
              return (
                <p
                  key={i}
                  data-testid={`about-not-line-${i}`}
                  className={`font-body text-base text-navy leading-snug ${
                    isLast ? "font-semibold" : ""
                  }`}
                >
                  {isLast ? (
                    <Check
                      size={18}
                      strokeWidth={2.25}
                      className="inline-block mr-2 -mt-1 text-coral"
                    />
                  ) : (
                    <span className="font-semibold text-coral mr-2">X</span>
                  )}
                  {line}
                </p>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
